import { render } from "./ApiResponse.vue?vue&type=template&id=2a6c9f86&scoped=true&ts=true"
import script from "./ApiResponse.vue?vue&type=script&lang=ts"
export * from "./ApiResponse.vue?vue&type=script&lang=ts"

import "./ApiResponse.vue?vue&type=style&index=0&id=2a6c9f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6c9f86"]])

export default __exports__